/**
 * Ponto de entrada do React — monta o App no DOM.
 *
 * Importa os estilos do Leaflet aqui para que estejam disponíveis
 * globalmente antes de qualquer componente de mapa renderizar.
 *
 * @module main
 */

import React, { Component, StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "leaflet/dist/leaflet.css";
import "./styles/theme.css";

import App from "./App";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "#fee",
          color: "#c00",
          padding: "20px",
          zIndex: 99999,
          fontFamily: "monospace",
          whiteSpace: "pre-wrap",
          overflowY: "auto"
        }}>
          <h2>Algo deu errado no React (Error Boundary)</h2>
          <p style={{ fontWeight: "bold", fontSize: "var(--text-title-sm)" }}>{this.state.error?.message}</p>
          <pre style={{ background: "#fff", padding: 10, borderRadius: 5, border: "1px solid #ecc" }}>
            {this.state.error?.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Elemento #root não encontrado no DOM.");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
